import { render, staticRenderFns } from "./FabricDialog.vue?vue&type=template&id=846cf4d2"
import script from "./FabricDialog.vue?vue&type=script&lang=js"
export * from "./FabricDialog.vue?vue&type=script&lang=js"
import style0 from "./FabricDialog.vue?vue&type=style&index=0&id=846cf4d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports